module.exports = __webpack_public_path__ + "img/feature_buy_zh.6b7ff21f.png";